import useGetPrivateMetadata from '../apps/insights/hooks/useGetPrivateMetadata.js';

export default function useIsPrivateDataLoading(companyId, sourceDetail) {
    const {data: privateMetadata, isLoading: isPrivateMetadataLoading} = useGetPrivateMetadata(sourceDetail.channel);
    if (isPrivateMetadataLoading) {
        return null;
    }
    const company = _.find(privateMetadata.companies, (company) => company.id === companyId);
    const isPrivateDataFetched = _.get(company, ['sources', sourceDetail.source, 'fetched']);
    return !isPrivateDataFetched;
}
